import { DETAIL_LOTTERIES_RULES } from './lotteriesRules.js'
import {
	ID_EL_GORDO,
	ID_EURO_MILLIONS,
	ID_POWERBALL,
	ID_MEGASENA,
	ID_NATIONAL,
	ID_UK_LOTTO,
	ID_THUNDERBALL,
	ID_MEGA_MILLIONS,
	ID_LOTTO_AMERICA,
	ID_NATIONAL_THURSDAY,
	ID_QUINA,
	ID_LOTTO_FACIL,
	ID_EL_GORDO_NAVIDAD,
	ID_EURODREAMS_PT,
	ID_EURODREAMS_FR,
	ID_LOTO_FR,
	ID_KENO_FR,
} from './idsLotteries.js'

import {
	ID_AUSTRIA,
	ID_BELGIUM,
	ID_FRANCE,
	ID_IRELAND,
	ID_LUXEMBOURG,
	ID_PORTUGAL,
	ID_SPAIN,
	ID_SWIRTZERLAND,
	ID_UK,
	ID_USA,
	ID_BRASIL,
	ID_EUROPE,
} from './idsCountries.js'

export const KENO_FR_TOTAL_NUMBERS = 10
export const lotteries = [...DETAIL_LOTTERIES_RULES]
export const IDS_LOTTERIES_CLASSIC = [ID_NATIONAL, ID_NATIONAL_THURSDAY, ID_EL_GORDO_NAVIDAD]

export const IDS_LOTTERIES_IS_NOT_MULTIPLE_BETS = [...IDS_LOTTERIES_CLASSIC, ID_EURODREAMS_PT, ID_EURODREAMS_FR]

export const rules_lotteries = {
	euromillions: {
		id: ID_EURO_MILLIONS,
		first_block: {
			min: 1,
			max: 50,
			total: 5,
		},
		last_block: {
			min: 1,
			max: 12,
			total: 2,
		},
	},
	el_gordo: {
		id: ID_EL_GORDO,
		first_block: {
			min: 1,
			max: 54,
			total: 5,
		},
		last_block: {
			min: 0,
			max: 9,
			total: 1,
		},
	},
	powerball: {
		id: ID_POWERBALL,
		first_block: {
			min: 1,
			max: 69,
			total: 5,
		},
		last_block: {
			min: 1,
			max: 26,
			total: 1,
		},
	},
	megasena: {
		id: ID_MEGASENA,
		first_block: {
			min: 1,
			max: 60,
			total: 6,
		},
		last_block: null,
	},
	loteria_nacional: {
		id: ID_NATIONAL,
		first_block: {
			min: 0,
			max: 9,
			total: 5,
		},
		last_block: null,
	},
	uk_lotto: {
		id: ID_UK_LOTTO,
		first_block: {
			min: 1,
			max: 59,
			total: 6,
		},
		last_block: {
			min: 1,
			max: 59,
			total: 1,
		},
	},
	thunderball: {
		id: ID_THUNDERBALL,
		first_block: {
			min: 1,
			max: 39,
			total: 5,
		},
		last_block: {
			min: 1,
			max: 14,
			total: 1,
		},
	},
	mega_millions: {
		id: ID_MEGA_MILLIONS,
		first_block: {
			min: 1,
			max: 70,
			total: 5,
		},
		last_block: {
			min: 1,
			max: 25,
			total: 1,
		},
	},
	lotto_america: {
		id: ID_LOTTO_AMERICA,
		first_block: {
			min: 1,
			max: 52,
			total: 5,
		},
		last_block: {
			min: 1,
			max: 10,
			total: 1,
		},
	},
	loteria_nacional_thursday: {
		id: ID_NATIONAL_THURSDAY,
		first_block: {
			min: 0,
			max: 9,
			total: 5,
		},
		last_block: null,
	},
	quina: {
		id: ID_QUINA,
		first_block: {
			min: 1,
			max: 80,
			total: 5,
		},
		last_block: null,
	},
	lotto_facil: {
		id: ID_LOTTO_FACIL,
		first_block: {
			min: 1,
			max: 25,
			total: 15,
		},
		last_block: null,
	},
	el_gordo_navidad: {
		id: ID_EL_GORDO_NAVIDAD,
		first_block: {
			min: 0,
			max: 9,
			total: 5,
		},
		last_block: null,
	},
	eurodreams_pt: {
		id: ID_EURODREAMS_PT,
		first_block: {
			min: 1,
			max: 40,
			total: 6,
		},
		last_block: {
			min: 1,
			max: 5,
			total: 1,
		},
	},
	eurodreams_fr: {
		id: ID_EURODREAMS_FR,
		first_block: {
			min: 1,
			max: 40,
			total: 6,
		},
		last_block: {
			min: 1,
			max: 5,
			total: 1,
		},
	},
	loto_fr: {
		id: ID_LOTO_FR,
		first_block: {
			min: 1,
			max: 49,
			total: 5,
		},
		last_block: {
			min: 1,
			max: 10,
			total: 1,
		},
	},
	keno_fr: {
		id: ID_KENO_FR,
		first_block: {
			min: 1,
			max: 70,
			min_select: 2,
			total: KENO_FR_TOTAL_NUMBERS,
		},
		last_block: null,
	},
}

export const countries = [
	{ id: ID_AUSTRIA, code: 'AT', flag: '🇦🇹', label: 'Austria', lotteries: [ID_EURO_MILLIONS] },
	{ id: ID_BELGIUM, code: 'BE', flag: '🇧🇪', label: 'Belgium', lotteries: [ID_EURO_MILLIONS] },
	{
		id: ID_FRANCE,
		code: 'FR',
		flag: '🇫🇷',
		label: 'France',
		lotteries: [ID_EURO_MILLIONS, ID_EURODREAMS_FR, ID_LOTO_FR, ID_KENO_FR],
	},
	{ id: ID_IRELAND, code: 'IE', flag: '🇮🇪', label: 'Ireland', lotteries: [ID_EURO_MILLIONS] },
	{ id: ID_LUXEMBOURG, code: 'LU', flag: '🇱🇺', label: 'Luxembourg', lotteries: [ID_EURO_MILLIONS] },
	{ id: ID_PORTUGAL, code: 'PT', flag: '🇵🇹', label: 'Portugal', lotteries: [ID_EURO_MILLIONS, ID_EURODREAMS_PT] },
	{
		id: ID_SPAIN,
		code: 'ES',
		flag: '🇪🇸',
		label: 'Spain',
		lotteries: [ID_EURO_MILLIONS, ID_EL_GORDO, ID_NATIONAL, ID_NATIONAL_THURSDAY, ID_EL_GORDO_NAVIDAD],
	},
	{ id: ID_SWIRTZERLAND, code: 'CH', flag: '🇨🇭', label: 'Switzerland', lotteries: [ID_EURO_MILLIONS] },
	{
		id: ID_UK,
		code: 'GB',
		flag: '🇬🇧',
		label: 'United Kingdom (UK)',
		lotteries: [ID_EURO_MILLIONS, ID_UK_LOTTO, ID_THUNDERBALL],
	},
	{
		id: ID_USA,
		code: 'US',
		flag: '🇺🇸',
		label: 'United States',
		lotteries: [ID_POWERBALL, ID_MEGA_MILLIONS, ID_LOTTO_AMERICA],
	},
	{ id: ID_BRASIL, code: 'BR', flag: '🇧🇷', label: 'Brasil', lotteries: [ID_MEGASENA, ID_QUINA, ID_LOTTO_FACIL] },
]

export const europeContent = {
	id: ID_EUROPE,
	code: 'EU',
	flag: '🇪🇺',
	label: 'Europe',
	lotteries: [ID_EURO_MILLIONS],
}

export const countriesIdsGlobalLottery = [ID_PORTUGAL, ID_SPAIN, ID_USA, ID_BRASIL, ID_UK, ID_FRANCE]

export const type_currency = [
	{ id: 1, slug: 'USD', icon: 'i-ion:logo-usd', symbol: '$', currency: 'en-US' },
	{ id: 2, slug: 'EUR', icon: 'i-tabler:currency-euro', symbol: '€', currency: 'en-US' },
	{ id: 3, slug: 'BRL', icon: 'i-tabler:currency-real', symbol: 'R$', currency: 'pt-BR' },
	{ id: 4, slug: 'GBP', icon: 'i-ph:currency-gbp-light', symbol: '£', currency: 'en-GB' },
]
